export default __webpack_public_path__ + "media/images/logo-symbol-wordmark-ed4f5675306182fac284ea854da94ea1.svg";